import { lang_en_US as translation } from "../../../../config";
import dayjs from "dayjs";
import { actionViewIcon } from "../../../../assets/images";
import { Tooltip, Typography, Checkbox } from "antd";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";
const { Link } = Typography;

export const activeDropdown = [
    { key: "ACTIVE", value: "ACTIVE" },
    { key: "INACTIVE", value: "INACTIVE" }
];

export const tabData = [
    { label: "Approval", content: translation?.lawyerManagement?.approveTitle, key: "1" },
    { label: "Rejected", content: translation?.lawyerManagement?.rejectedTitle, key: "2" }
];

export const complaintesTabData = [
    { label: "Complaints Against Advocate", content: translation?.lawyerManagement?.complaintsAgaintlawerTitle, key: "1" },
    { label: "Complaints Raised Advocate", content: translation?.lawyerManagement?.complaintsRaisedlawyerTitle, key: "2" },
    { label: "Support", content: "support", key: "3" }
];

export const consultationTabData = [
    { label: "Completed Consultation", content: "COMPLETED", key: "1" },
    { label: "Cancelled Consultation", content: "CANCELLED", key: "2" },
    { label: "Upcoming Consultation", content: "PENDING", key: "3" },
    { label: "Auto Cancelled Cons.", content: "AUTO_CANCELLED", key: "4" }
];

export const LAWYER_EDITABLE_FIELDS = [
    "salutation",
    "firstName",
    "middleName",
    "lastName",
    "barCouncilId",
    "experience",
    "qualification",
    "aboutAs",
    "stateCode",
    "districtCode",
    "cityCode",
    "pincode",
    "address1",
    "address2",
    "enrollmentNo",
    "email",
    "specialization"
];

export const APPROVAL_HEADER_COLUMNS = ({
    actionRender,
    handleDocuments,
    userStatus,
    handleBankDetails,
    selectedLawyerIds = [],
    handleSelectAll,
    isAllSelected = false,
    isIndeterminate = false,
    handleSelectLawyer,
    showCheckbox = false
}) => [
    {
        title: showCheckbox ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <Checkbox
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={(event) => handleSelectAll && handleSelectAll(event.target.checked)}
                    onClick={(event) => event?.stopPropagation()}
                />
                <span>S.No.</span>
            </div>
        ) : "S.No.",
        align: "center",
        width: showCheckbox ? 80 : 60,
        render: (_, detail, index) => {
            if (!showCheckbox) {
                return index + 1;
            }
            const lawyerId = detail?.lawyerId || detail?.id;
            const isChecked = Boolean(selectedLawyerIds?.includes(lawyerId));
            return (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                    <Checkbox
                        checked={isChecked}
                        onChange={(event) => {
                            event?.stopPropagation();
                            handleSelectLawyer && handleSelectLawyer(lawyerId, detail);
                        }}
                        onClick={(event) => event?.stopPropagation()}
                    />
                    <span>{index + 1}</span>
                </div>
            );
        }
    },
    {
        title: "Date",
        align: "center",
        width: 100,
        render: (detail) => dayjs(detail?.date).format("DD-MM-YYYY")
    },
    {
        title: "Advocate ID",
        width: 120,
        align: "center",
        dataIndex: "lawyerNo",
    },
    {
        title: "Advocate Name",
        width: 200,
        align: "center",
        render: (_, detail) => {
            const first = detail?.firstName || "";
            const middle = detail?.middleName || "";
            const last = detail?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName || "Nil"}</p>
                    )}
                </>
            );
        }
    },
    {
        title: "Bar Council ID",
        width: 120,
        render: (detail) => <>{detail?.barCouncilId || "Nil"}</>

    },
    {
        title: "Enrolment No.",
        width: 120,
        align: "center",
        dataIndex: "enrollmentNo",
        render: (enrollmentNo) => enrollmentNo || "Nil"
    },
    {
        title: "Cell Number",
        width: 160,
        align: "center",
        render: (_, detail) => {
            return <><p style={{ padding: 0, margin: 0 }}>{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</p></>
        },
    },
    {
        title: "Email",
        width: 180,
        render: (detail) => {
            return <>{detail?.email || "Nil"}</>
        },
    },
    {
        title: "Total Cons.",
        width: 100,
        align: "center",
        dataIndex: "totalConsultation",
        render: (_, detail) => {
            return <>{detail?.totalConsultation}</>
        }
    },
    {
        title: "Upcoming Cons.",
        width: 100,
        align: "center",
        dataIndex: "upcomingConsultation",
        render: (_, detail) => {
            return <>{detail?.upcomingConsultation}</>
        }
    },
    {
        title: "Total Cancelled Cons.",
        width: 150,
        align: "center",
        dataIndex: "totalCancelConsultation",
        render: (_, detail) => {
            return <>{detail?.totalCancelConsultation}</>
        }
    },
    {
        title: "This Month Cancelled Cons.",
        width: 150,
        align: "center",
        dataIndex: "thisMonthCancelledConsultations",
        render: (_, detail) => {
            return <>{detail?.consultationCancelCountDetails?.thisMonthCancelCount || "0"}</>
        }
    },
    {
        title: "Recorded Complaint",
        width: 150,
        align: "center",
        dataIndex: "thisMonthRecordedComplaint",
        render: (_, detail) => detail?.customerComplaintCount?.thisMonthRecordComplaintCount ?? detail?.LawyerComplaintCount?.thisMonthRecordComplaintCount ?? "0"
    },
    {
        title: "Non recorded complaint",
        width: 150,
        align: "center",
        dataIndex: "thisMonthNonRecordedComplaint",
        render: (_, detail) => detail?.customerComplaintCount?.thisMonthNonRecordComplaintCount ?? detail?.LawyerComplaintCount?.thisMonthNonRecordComplaintCount ?? "0"
    },
    {
        title: "Total Earned",
        width: 100,
        align: "center",
        render: (_, detail) => {
            return <>&#8377; {formatAmount(detail?.myEarnings)}</>
        },
    },
    {
        title: "Warning Count",
        dataIndex: "warningCount",
        width: 110,
        align: "center",
        render: (warningCount) => warningCount ?? "Nil"
    },
    {
        title: "Documents",
        width: 120,
        align: "center",
        dataIndex: "documents",
        render: (_, detail) => {
            return <>
                <Link onClick={(event) => {
                    event?.stopPropagation();
                    handleDocuments(detail);
                }}>View</Link>
            </>
        }
    },
    {
        title: "Bank details",
        width: 120,
        align: "center",
        dataIndex: "bankDetails",
        render: (_, detail) => {
            return <>
                <Link onClick={(event) => {
                    event?.stopPropagation();
                    handleBankDetails && handleBankDetails(detail);
                }}>View</Link>
            </>
        }
    },
    ...(userStatus === "HOLD" ? [
        {
            title: "Block Days",
            width: 100,
            render: (detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                return <>{lastBlock?.blockDays}</>
            }
        },
        {
            title: "Block Date",
            width: 100,
            render: (detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                return <>{lastBlock?.blockDate ? dayjs(lastBlock?.blockDate).format("DD-MM-YYYY") : ""}</>
            }
        },
        {
            title: "Reason for Block",
            width: 180,
            render: (_, detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                const reason = lastBlock?.reason || "Nil";
                if (reason?.length > 20) {
                    return <Tooltip title={reason}>
                        <span>{reason?.slice(0, 20)}...</span>
                    </Tooltip>
                }
                return <><span>{reason}</span>
                </>
            }
        }
    ] : []),
    {
        title: "Action",
        width: 80,
        fixed: "right",
        render: (detail) => actionRender(detail)
    }
];

export const REJECTED_HEADER_COLUMNS = ({
    handleRejectedLawyers,
    handleDocuments,
    handleBankDetails,
    selectedLawyerIds = [],
    handleSelectAll,
    isAllSelected = false,
    isIndeterminate = false,
    handleSelectLawyer,
    showCheckbox = false
}) => [
    {
        title: showCheckbox ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <Checkbox
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={(event) => handleSelectAll && handleSelectAll(event.target.checked)}
                    onClick={(event) => event?.stopPropagation()}
                />
                <span>S.No.</span>
            </div>
        ) : "S.No.",
        align: "center",
        width: showCheckbox ? 80 : 60,
        render: (_, detail, index) => {
            if (!showCheckbox) {
                return index + 1;
            }
            const lawyerId = detail?.lawyerId || detail?.id;
            const isChecked = Boolean(selectedLawyerIds?.includes(lawyerId));
            return (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                    <Checkbox
                        checked={isChecked}
                        onChange={(event) => {
                            event?.stopPropagation();
                            handleSelectLawyer && handleSelectLawyer(lawyerId, detail);
                        }}
                        onClick={(event) => event?.stopPropagation()}
                    />
                    <span>{index + 1}</span>
                </div>
            );
        }
    },
    {
        title: "Date",
        width: 80,
        align: "center",
        render: (detail) => dayjs(detail?.date || detail?.approvalInfo?.approvalDate || detail?.approvalDate).format("DD-MM-YYYY")
    },
    {
        title: "Advocate ID",
        width: 120,
        align: "center",
        dataIndex: "lawyerNo"
    },
    {
        title: "Advocate Name",
        align: "center",
        width: 200,
        render: (_, detail) => {
            const first = detail?.firstName || "";
            const middle = detail?.middleName || "";
            const last = detail?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 5;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            const shouldShowTooltip =
                (first && middle && last) || isLastLong;
            return (
                <>
                    {shouldShowTooltip ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName || "Nil"}</p>
                    )}
                </>
            );
        }
    },
    {
        title: "Bar Council ID",
        width: 120,
        render: (detail) => {
            return <>{detail?.barCouncilId || "Nil"}</>
        }
    },
    {
        title: "Enrolment No.",
        width: 120,
        align: "center",
        dataIndex: "enrollmentNo",
        render: (enrollmentNo) => enrollmentNo || "Nil"
    },
    {
        title: "Cell Number",
        width: 160,
        align: "center",
        render: (_, detail) => {
            return <><p style={{ padding: 0, margin: 0 }}>{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</p></>
        },
    },
    {
        title: "Email",
        width: 180,
        render: (detail) => {
            return <>{detail?.email || "Nil"}</>
        }
    },
    {
        title: "Documents",
        align: "center",
        width: 100,
        render: (_, detail) => {
            return <>
                <Link onClick={(event) => {
                    event?.stopPropagation();
                    handleDocuments(detail);
                }}>View</Link>
            </>
        }
    },
    {
        title: "Bank details",
        align: "center",
        width: 120,
        render: (_, detail) => {
            return <>
                <Link onClick={(event) => {
                    event?.stopPropagation();
                    handleBankDetails && handleBankDetails(detail);
                }}>View</Link>
            </>
        }
    },
    {
        title: "Reason",
        dataIndex: "rejectedReason",
        width: 140,
        render: (_, detail) => {
            const reason = detail?.approvalInfo?.rejectedReason || "Nil";
            if (reason?.length > 20) {
                return <Tooltip title={reason}>
                    <span>{reason?.slice(0, 20)}...</span>
                </Tooltip>
            }
            return <><span>{reason}</span>
            </>
        }
    },
    {
        title: "Action",
        width: 80,
        fixed: "right",
        render: (detail) => <div style={{ textAlign: "center" }}>
            <img src={actionViewIcon} alt="" style={{ cursor: "pointer" }} onClick={(event) => {
                event?.stopPropagation();
                handleRejectedLawyers(detail);
            }} />
        </div>
    }
];

export const actionDropdownMenu = [
    { key: "view", label: "View" },
    { key: "hold", label: "Hold" },
    // { key: "editHistory", label: "Edit History" },
    { key: "complaints", label: "Complaints" },
    { key: "consultation", label: "Consultation" }
];

export const EDIT_HISTORY_COLUMNS = ({ handleViewEditHistory }) => [
    {
        title: "Date",
        width: 180,
        align: "center",
        render: (_, detail) => <>{detail?.revisedDate ? dayjs(detail?.revisedDate).format("DD-MM-YYYY HH:mm:ss") : "Nil"}</>
    },
    {
        title: "Action",
        width: 80,
        align: "center",
        render: (_, detail) => {
            return <img
                src={actionViewIcon}
                alt="View"
                style={{ cursor: "pointer" }}
                onClick={(event) => {
                    event?.stopPropagation();
                    handleViewEditHistory(detail);
                }}
            />;
        }
    }
];

export const completeConsultationDropdown = [
    { key: "view", label: "View" },
    { key: "viewComplaint", label: "View Complaints" },
    { key: "viewLawyerRasiedComplaints", label: "View Advocate Rasied Complaint" },
    { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
];

export const pendingConsultationDropdown = [
    { key: "view", label: "View" },
];

export const complaintAgainstDropdown = [
    { key: "view", label: "View" },
    { key: "report", label: "Download Report" }
];